import React from 'react'
import { withRouter } from 'react-router-dom'
import { Switch } from '@softwaredev_cegeka/stix-form'
import { Button, Icon, Popover } from '@softwaredev_cegeka/stix-core'

import EntityTable from './EntityTable'
import { debouncedLoadData } from 'src/utils/utils'

function TenantUsersTable({
    data,
    loading,
    params,
    setParams,
    deleteAction,
    history,
    match,
    displayNamespace,
    removeUserAsTenantAdmin,
}) {
    const renderConfirmationModal = row => {
        const confirmationMessage = `Are you sure you want to make user ${row.first_name} ${row.last_name} not a tenant admin of this group?`
        return (
            <div className="modal-wrapper">
                <div>{confirmationMessage}</div>
                <div className="button-modal-wrapper">
                    <Button
                        variant={'outline-danger'}
                        onClick={() => removeUserAsTenantAdmin(row.id)}
                    >
                        Confirm
                    </Button>
                </div>
            </div>
        )
    }

    const columns = [
        {
            Header: 'Users',
            accessor: 'name',
            Cell: ({ cell }) => {
                const entry = cell.row.original
                return (
                    <div>
                        {`${entry.first_name} ${entry.last_name}`}
                        <div className={'user-email-display'}>
                            {entry.email}
                        </div>
                    </div>
                )
            },
            width: '60%',
        },
        {
            Header: 'Tenant Admin',
            accessor: 'tenants',
            Cell: ({ cell }) => {
                const switchProps = {
                    checked: true,
                    disabled: true,
                    srOnly: true,
                    label: 'Tenant Admin',
                }
                return <Switch {...switchProps} />
            },
            width: '20%',
        },
        {
            accessor: 'remove-action',
            Cell: ({ cell }) => {
                return (
                    <Popover
                        rootClose={true}
                        placement="left"
                        trigger="click"
                        content={renderConfirmationModal(cell.row.original)}
                    >
                        <Button variant="naked">
                            <Icon icon={'delete'} />
                        </Button>
                    </Popover>
                )
            },
            width: '20%',
        },
    ]

    const columnsToFilter = [
        {
            column: 'first_name',
        },
        {
            column: 'last_name',
        },
        {
            column: 'email',
        },
    ]

    function handleFilterChange(entries) {
        // Reset to show al results after clear filters is clicked.
        if (entries.length === 0) {
            setParams({})
            return
        }

        // Update params with new selected filter and send them back to the route.
        entries.forEach(item => {
            Object.entries(item).forEach(([key, value]) => {
                if (key === 'service') {
                    params['namespace_like'] = value.toString()
                } else {
                    params[key + '_like'] = value.toString()
                }
            })
        })

        setParams(params)
    }

    function handleGlobalFilter(value) {
        // check all columns on entry
        columnsToFilter.forEach(col => {
            params[col.column + '_like'] = value.toString()
        })
        params.use_or = true
        debouncedLoadData(params, setParams)
    }

    return (
        <EntityTable
            loading={loading}
            data={data}
            columns={columns}
            columnsTofilter={columnsToFilter}
            onColumnFilter={handleFilterChange}
            onGlobalFilter={handleGlobalFilter}
        />
    )
}

export default withRouter(TenantUsersTable)
